<template>
    <page-main>
        <div class="container">
            <div class="page-border">
                <query v-model="query" syear semester keyword="編號、名稱、地點">
                    <div class="col-md col-sm-12">
                        <form-select v-model="query.property" id="job" label="活動性質">
                            <div is="option" value="">全部</div>
                            <div is="option" v-for="o in propertys" :key="o.key" :value="o.key">{{o.value}}</div>
                        </form-select>
                    </div>
                </query>
                <btn-group :load="reload" :insert="insert" :del="del" :deleteItems="deleteItem.length"></btn-group>
            </div>
            <div class="page-border">
                <table class="table">
                    <thead>
                        <tr>
                            <th style="width:30px;"></th>
                            <th>學年度-學期</th>
                            <th>編號-名稱</th>
                            <th>活動性質</th>
                            <th>日期</th>
                            <th>地點</th>
                        </tr>
                    </thead>
                    <tr v-for="item in tableData.value" :key="item.CounselingID">
                        <td data-th="選擇"><input type="checkbox" v-model="deleteItem" :value="item.CounselingID" /></td>
                        <td data-th="學年度-學期">{{item.SYear}}-{{item.Semester|semester}}</td>
                        <td data-th="編號-名稱"><b-button size="sm" variant="link" @click="edit(item.CounselingID)">{{item.No}}-{{item.Name}}</b-button></td>
                        <td data-th="活動性質">{{item.Property|property}}</td>
                        <td data-th="日期">{{item.Start|date('yyyy/mm/dd')}} - {{item.End|date('yyyy/mm/dd')}}</td>
                        <td data-th="地點">{{item.Place}}{{item.CrossSchool|crossschool}}</td>
                    </tr>
                </table>
                <pagination v-model="pager" :rows="tableData.count" :rowperpage="10" @paging="load"></pagination>
            </div>
        </div>
        <Detail id="info" :modalkey="modalkey" @reload="reload" @edit="edit">
            <template slot="property">
                <div is="option" v-for="o in propertys" :key="o.key" :value="o.key">{{o.value}}</div>
            </template>
        </Detail>
    </page-main>
</template>

<script>
    import Detail from './counselingDetail.vue';
    import { master } from '@/views';
    export default master({
        name: 'counseling',
        api: '/api/counseling/',
        components: { Detail },
        data: { propertys: [] },
        created: function () {
            window.propertys = [];
            this.$parameter.activity()
                .then((res) => {
                    let newData = res.data.filter(function (item) {
                        return item.key.startsWith('C5-2');
                    });
                    window.propertys = this.propertys = newData;
                });
        },
        filters: {
            property: function (value) { let a = window.propertys.filter(x => x.key == value); return a.length > 0 ? a[0].value : ''; },
            crossschool: function (value) { return value ? '(跨校)' : ''; }
        }
    });
</script>

<style>
</style>